// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vc-chrome-fields-wrap,\n.vc-alpha-container,\n.vc-alpha-picker,\n.vc-alpha-gradient,\n.vc-checkerboard,\n.vc-chrome-color-wrap {\n  display: none !important;\n}\n.vc-chrome {\n  box-shadow: none !important;\n}\n.vc-chrome {\n  width: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
